/* Approved FAQ card presentation and responsive author biography. */
(()=>{
  const desktop=matchMedia('(min-width:750px)');
  function mount(){
    document.querySelectorAll('.article-faq-metafield__item').forEach((item,i)=>{
      if(item.dataset.ftFaqReady)return;
      const row=item.querySelector('.article-faq-metafield__row');
      const question=row?.querySelector('.article-faq-metafield__q');
      const answer=item.querySelector('.article-faq-metafield__answer');
      if(!row||!question||!answer)return;
      item.dataset.ftFaqReady='true';
      const heading=document.createElement('h3');heading.className='ft-faq-question-heading';
      const button=document.createElement('button');button.type='button';button.className=row.className;
      for(const child of [...row.childNodes])button.append(child);
      const text=document.createElement('span');text.className=question.className;text.replaceChildren(...question.childNodes);question.replaceWith(text);
      const icon=document.createElement('span');icon.className='faq-toggle-icon';icon.setAttribute('aria-hidden','true');button.append(icon);
      heading.append(button);row.replaceWith(heading);
      answer.id=answer.id||`${item.closest('section').id}-answer-${i}`;
      button.setAttribute('aria-controls',answer.id);
      const setOpen=open=>{item.classList.toggle('is-open',open);button.setAttribute('aria-expanded',String(open));icon.textContent=open?'−':'+';answer.setAttribute('aria-hidden',String(!open));};
      setOpen(true);button.addEventListener('click',()=>setOpen(!item.classList.contains('is-open')));
    });
    document.querySelectorAll('.ft-profile-card__description details').forEach(d=>{if(!d.dataset.ftResponsiveReady){d.dataset.ftResponsiveReady='true';d.open=desktop.matches;}});
  }
  desktop.addEventListener('change',()=>document.querySelectorAll('.ft-profile-card__description details').forEach(d=>d.open=desktop.matches));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();
